export default {
  login: {
    name: 'signin',
    route:'/signin'
  },
  logout: {
    name: 'signout',
  },
  user: {
    userKey: 'data'
  },
}